module.exports = __webpack_public_path__ + "img/lens-160-plus-08.8ae56fd9.png";